module.exports = __webpack_public_path__ + "media/src/assets/Images/WhiteCheck-34e63731128f76c0c7fd21543df2794d.svg";